import axios from '@/utils/ajax';

/**
 * 律师自助注销（冷静期）相关接口
 * 需求：线上注销资质流程优化 legal-all-14906
 */

// 身份三要素校验并提交注销申请
export const verifyDeregister = data => axios({
    method: 'post',
    url: '/bp/api/lawyer/deregister/verify',
    data
});

// 查询当前注销申请状态
export const getDeregisterStatus = () => axios({
    method: 'get',
    url: '/bp/api/lawyer/deregister/status'
});

// 撤回注销申请
export const withdrawDeregister = () => axios({
    method: 'post',
    url: '/bp/api/lawyer/deregister/withdraw'
});
